// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xqno","controls":"styles_controls__1LAX1","charLimit":"styles_charLimit__uKE7X","input":"styles_input__1HFf7","send":"styles_send__24wIu"};